/**
 * Similar to Required<T>, but only provided properties are marked as required.
 *
 * Usage:
 *     type ContactInfo = RequiredProperties<Partial<UserProfile>, 'name' | 'email'>
 *
 * @see Required
 */
export type RequiredProperties<T, K extends keyof T> = Partial<T> & {
  [P in K]-?: T[P];
};
